<app-item [entity]="sport" *ngIf="sport" [deleteService]="deleteService" [deleteButtonInMore]="true">
    <app-luna-button more-buttons iconName="pencil" (clickedEvent)="edit()"></app-luna-button>
    <app-summary [expandable]="true">
        <ng-container title>{{sport?.sport?.label}}</ng-container>
        <div expandedContent class="d-flex gap flex-wrap">
            <app-lov-value-summary-field *ngIf="sport.sport" [lovValueSummary]="sport.sport" />
            <app-lov-value-summary-field *ngIf="sport.type" [lovValueSummary]="sport.type" />
            <app-lov-value-summary-field *ngIf="sport.frequency" [lovValueSummary]="sport.frequency" label="Fréquence" />
            <app-lov-value-summary-field *ngIf="sport.flooring" [lovValueSummary]="sport.flooring" label="Surface" />
            <app-summary-field *ngIf="sport.periodAsLabel" [value]="sport.periodAsLabel" />
            <app-comment-summary-field *ngIf="sport.comment" [comment]="sport.comment" />
        </div>
    </app-summary>
</app-item>